import React from 'react'
import SmtpContainer from '../../containers/admin_portal/smtp_config';

const SmtpConfigPage = () => {
  return <SmtpContainer/>
}

export default SmtpConfigPage;
